import { DEFAULT_PERMISSIONS, PERMISSION_GROUPS } from "~/constants/permissions"

export const permissionAllowed = (
  permissionGroup,
  userPermissionGroup,
  permissionType,
  userPermissions,
) => {
  let allowed = false
  if (
    permissionGroup &&
    PERMISSION_GROUPS?.indexOf(userPermissionGroup) <=
      PERMISSION_GROUPS?.indexOf(permissionGroup)
  ) {
    allowed = true
  }

  const permissionInDefaultPermissions =
    DEFAULT_PERMISSIONS?.includes(permissionType)
  if (
    permissionType &&
    (userPermissions?.includes(permissionType) ||
      !permissionInDefaultPermissions)
  ) {
    allowed = true
  }
  return allowed
}
